<template>
    <v-card>
        <div v-padding="3">
            <div v-margin.bottom="2">
                <v-text type="title">
                    В наших инструкциях вы сможете ознакомиться с
                    примерами отчетов сервиса, их наполнением,
                    источниками данных и советами по интерпретации.</v-text>
            </div>

            <v-list v-margin.bottom="2">
                <v-list-item>
                    <v-link :to="'/public/instructions/KPFL.pdf'" target="_blank">
                        Комплексная проверка
                        физического лица
                    </v-link>
                </v-list-item>
                <v-list-item>
                    <v-link :to="'/public/instructions/KR.pdf'" target="_blank">
                        Кредитный рейтинг
                    </v-link>
                </v-list-item>
                <v-list-item>
                    <v-link :to="'/public/instructions/KOFL.pdf'" target="_blank">
                        Кредитный отчет
                    </v-link>
                </v-list-item>
                <v-list-item>
                    <v-link :to="'/public/instructions/Dossier.pdf'" target="_blank">
                        Досье
                    </v-link>
                </v-list-item>
            </v-list>
        </div>
    </v-card>
</template>
<script>
export default {
    name: 'instraction'
};
</script>


// WEBPACK FOOTER //
// Instraction.vue?4bf3a4ab